/**
 * GlobalAlert
 * Functions for the global alert feature
 * @version 1.0.0
 * @exports GlobalAlert
 * */
export default class GlobalAlert {

    constructor() {
        // grab all the alerts on the page
        const alerts = document.querySelectorAll('.alert');

        // loop through them, and show the ones that hasn't yet been dismissed
        alerts.forEach(alert => {
            if (sessionStorage.getItem(alert.dataset.alertkey) === null) {
                alert.classList.remove('d-none');
            }
        });


        // grab all dismiss buttons
        const alertDismissButtons = document.querySelectorAll('.alert-dismissible button');

        // and wire up a event for when the user clicks on them
        alertDismissButtons.forEach(button => {
            button.addEventListener('click', this._onDismissClick);
        });
    }

    _onDismissClick(event) {
        // grab the alert key from the event target dataset attributes
        const alertKey = event.target.dataset.alertkey;

        // save the dismissed alert to sessionStorage to keep it from being
        // rendered again during the same session
        sessionStorage.setItem(alertKey, 'dismissed');
    }
}